import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './style';

const Footer = React.memo(() => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <div className={s.Footer}>
      <div dangerouslySetInnerHTML={{ __html: t('components.footer.innKpp') }} />
      <div dangerouslySetInnerHTML={{ __html: t('components.footer.address') }} />
      <div className={s.FooterDeveloper}>
        <a
          href="https://nedvex.ru/%D0%90%D1%80%D1%85%D0%B8%D0%B2.zip"
          target="__blank"
          dangerouslySetInnerHTML={{ __html: t('components.footer.softDeveloper') }}
        />
      </div>
      <div className={s.Documents}>
        <div>{t('components.footer.copied', { year })}</div>
        <div className={s.DocumentLinks}>
          <a href="https://app.nedvex.ru/consent" target="__blank">
            {t('components.footer.consent')}
          </a>
          <a href="https://app.nedvex.ru/policy" target="__blank">
            {t('components.footer.policy')}
          </a>
          <a href="https://app.nedvex.ru/eula" target="__blank">
            {t('components.footer.eula')}
          </a>
          <a href="https://app.nedvex.ru/about" target="__blank">
            {t('components.footer.about')}
          </a>
        </div>
      </div>
    </div>
  );
});

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js